import React from 'react';
import {ProtectedPage} from './bundles/common/components/ProtectedPage';
import {Home} from './bundles/home/Home';
import {Auth} from './bundles/auth/components/Auth';
import {Sandbox} from './bundles/sandbox/Sandbox';
import {Private} from './bundles/private/Private';
// import {UserRoles} from './core/constants/userRoles';

export const routes = [
  <Home key="home" path="/"/>,
  <Home key="home" path="/home/*"/>,
  <Auth key="auth" path="/*"/>,
  <ProtectedPage key="private" path="/private/*" pageComponent={<Private/>} />,
  // <ProtectedPage key="admin" path="/admin" requireRole={UserRoles.administrator} pageComponent={<Admin/>} />,
  <Sandbox key="sandbox" path="/sandbox"/>,
];
